import { Component, OnInit, ViewChild } from '@angular/core';
import { IdentityService } from 'src/app/@core/services/identity.service';
import { HomeAdvertisingModel, HomeAdvertisingType } from '../../models/home-advertising.model';
import { environment } from 'src/environments/environment';
import { HomeService } from '../../services/home.service';
import { CarouselResize } from 'src/app/shared/models/carousel-resize';
import { CustomCarouselComponent } from 'src/app/shared/components/custom-carousel/custom-carousel.component';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from 'src/app/shared/models/item.model';

@Component({
  selector: 'app-advertisements',
  templateUrl: './advertisements.component.html',
  styleUrls: ['./advertisements.component.scss'],
})
export class AdvertisementsComponent implements OnInit {
  active: number = 0;
  isRtl: boolean = true;
  isAdsCarousel: boolean = true;
  advertisingType = HomeAdvertisingType
  resources = environment.homeImageResource + '/';
  carouselResize: CarouselResize<HomeAdvertisingModel> = {
    data: [],
    items: [],
    itemSizeSm: 1,
    itemSizeMd: 1,
    itemSizeLg: 1,
    itemResize: 0,
    innerWidth: 0,
    currentIndex: 0,
    slideDelay: 20000,
  };
  @ViewChild('appCustomCarousel')
  appCustomCarousel: CustomCarouselComponent<HomeAdvertisingModel>;

  constructor(
    private homeService: HomeService,
    private languageService: LanguageService,
    private _IdentityService: IdentityService
  ) {}

  /** Unified Code mode: tokenised layout (styles/unified-code/components/_home.scss). */
  get isUnified(): boolean {
    return this._IdentityService.isUnifiedCode();
  }

  ngOnInit(): void {
    this.isRtl = this.languageService.getCurrentLanguage() === LanguageEnum.ar;
    this.languageService.languageChange.subscribe((result: LanguageEnum) => (this.isRtl = result === LanguageEnum.ar));
    this.loadData();
  }

  loadData(): void {
    this.homeService.getAdvertisements().subscribe((result: HomeAdvertisingModel[]) => (this.carouselResize.data = result));
  }

  onClick(index: number, url: string) {
    if (this.active !== index) {
      this.active = index;
      return;
    }
    window.open(url, '_blank');
  }
}
